import { render, staticRenderFns } from "./ErrorSubmitForm22.vue?vue&type=template&id=550b9c5e&scoped=true"
import script from "./ErrorSubmitForm22.vue?vue&type=script&lang=ts"
export * from "./ErrorSubmitForm22.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550b9c5e",
  null
  
)

export default component.exports